import BaseService from './baseService';

function limparReferenciasJson(valor, ancestrais = []) {
  if (valor === null || typeof valor !== 'object') {
    return valor;
  }

  if (valor instanceof Date) {
    return valor.toJSON();
  }

  if (ancestrais.indexOf(valor) !== -1) {
    return undefined;
  }

  if (Array.isArray(valor)) {
    return valor
      .map(item => limparReferenciasJson(item, ancestrais.concat(valor)))
      .filter(item => item !== undefined);
  }

  const resultado = {};
  const novosAncestrais = ancestrais.concat(valor);

  Object.keys(valor).forEach(chave => {
    if (chave === '$id' || chave === '$ref') {
      return;
    }

    const item = limparReferenciasJson(valor[chave], novosAncestrais);
    if (item !== undefined) {
      resultado[chave] = item;
    }
  });

  return resultado;
}

export default {
  getFornecedor(NumCgcFornecedor) {
    return BaseService.get("fornecedor/consultarfornecedor?NumCgcFornecedor=" + NumCgcFornecedor);
  },

  getFornecedorSIMPAS(NumCgcFornecedor, RetornaErroHabilitado = null) {
    let parametroRetornaErro = RetornaErroHabilitado ? `&RetornaErroHabilitado=${RetornaErroHabilitado}` : "";
    return BaseService.get("fornecedor/consultarfornecedorsimpas?NumCgcFornecedor=" + NumCgcFornecedor + parametroRetornaErro);
  },

  getSolicitarAlteracao(NumCgcFornecedor) {
    return BaseService.get("fornecedor/solicitaralteracao" +
     (NumCgcFornecedor ? `?NumCgcFornecedor=${NumCgcFornecedor}`:""));
  },

  getSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/ConsultarSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  fornecedorReabrirSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/FornecedorReabrirSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  fornecedorCancelarSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/FornecedorCancelarSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  listarPCEsFornecedor() {
    return BaseService.get("fornecedor/listarPCEsFornecedor");
  },

  visualizarSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/visualizarSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  getResumoSolicitacao(idFornecSolicitacao) {
    return BaseService.get("fornecedor/ResumoSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao);
  },

  getAlteracoesSolicitacao(model) {
    return BaseService.post("fornecedor/RetornaAlteracaoSolicitacao", model);
  },
  atualizarSituacaoSolicitacao(model) {
    return BaseService.post(
      "fornecedor/atualizarsituacaosolicitacao", model);
  },
  enviarArquivoSEI(model) {
    return BaseService.post("fornecedor/EnviarArquivoSEI", model);
  },

  getSolicitacaoIncluiSimpas(idFornecSolicitacao) {
    return BaseService.get("fornecedor/ConsultarSolicitacao?IdFornecSolicitacao=" + idFornecSolicitacao +"&incluirSimpas=true");
  },

  getModelFornecedor() {
    return BaseService.get("fornecedor/modelfornecedor");
  },

  getListaFornecedorHabilitacaoJuridica() {
    return BaseService.get("fornecedor/consultarlistahabilitacaojuridica");
  },

  getSolicitacaoFornecedor(model) {
    return BaseService.post("fornecedor/listarsolicitacaofornecedor", model);
  },
  getProximaSolicitacaoAnalista(usuarioAnalistaId, IdFornecSolicitacao) {
    return BaseService.get(`fornecedor/getproximasolicitacaoanalista/${usuarioAnalistaId}/${IdFornecSolicitacao}`);
  },
  getFornecedorNome(NumCgcFornecedor) {
    return BaseService.get("duplaconferencia/getFornecedorNome?NumCgcFornecedor=" + NumCgcFornecedor);
  },
  
  cadastrarDuplaConferencia(model){
    return BaseService.post("duplaconferencia/cadastrarDuplaConferencia", model);
  },

  validaDuplaConferencia(model){
    return BaseService.post("duplaconferencia/validaDuplaConferencia", model.fornecedorSolicitacao);
  },

  getDuplaConferencia(){
    return BaseService.get("duplaconferencia/listarDuplaConferencia");
  },

  getListaCadastro(model){
    return BaseService.post("fornecedor/SolicitacaoComprasnetSimpas", model);
  },

  exportarExcel(model, tipo) {
    return BaseService.exportarExcel(model, tipo);
  },

  atribuirAnalistaFornecedor(model,usuarioAnalistaId) {
    let _usuarioAnalistaId = usuarioAnalistaId ? usuarioAnalistaId : "";
    return BaseService.post("fornecedor/atribuiranalistafornecedor/"+_usuarioAnalistaId, model);
  },
  
  atribuirAnalistaFornecedorLista(model,usuarioAnalistaId) {
    let _usuarioAnalistaId = usuarioAnalistaId ? usuarioAnalistaId : "";
    return BaseService.post("fornecedor/atribuiranalistafornecedorLista/"+_usuarioAnalistaId, model);
  },

  listarSolicitacoes(NumCgcFornecedor) {
    return BaseService.get("fornecedor/ListarSolicitacoes?NumCgcFornecedor=" + NumCgcFornecedor);
  },

  listarHistoricoSolicitacoes(situacaoSolicitacao) {
    return BaseService.get("fornecedor/listarhistoricosolicitacao?situacaoSolicitacao=" + situacaoSolicitacao);
  },

  cadastrarRepresentanteLegal(model){
    return BaseService.post("Fornecedor/cadastrarrepresentantelegal", model);
  } ,

  getRepresentanteLegal(idRepresentanteLegal) {
    return BaseService.get("fornecedor/consultarrepresentante?IdRepresentanteSolicitacao=" + idRepresentanteLegal);
  },

  getRepresentanteLegalUnico(idRepresentanteLegal) {
    return BaseService.get("fornecedor/consultarrepresentanteunico?IdRepresentanteSolicitacao=" + idRepresentanteLegal);
  },
  

  getRepresentanteLegalFornecedor(numCgcFornecedor){
    return BaseService.get("fornecedor/consultaRepresentanteFornecedor?NumCgcFornecedor="+numCgcFornecedor);
  },

  cadastrarfornecedor(model) {  
    console.log('%c[DEBUG-SERVICO-CADASTRO] >>> INÍCIO cadastrarfornecedor()', 'background: #9c27b0; color: white; padding: 4px; font-size: 12px');
    console.log('%c[DEBUG-SERVICO-CADASTRO] model.listaRegularidadeFiscTrab ANTES sanitização:', { 
      total: model.listaRegularidadeFiscTrab ? model.listaRegularidadeFiscTrab.length : 0,
      items: JSON.parse(JSON.stringify(model.listaRegularidadeFiscTrab)) 
    });
    
    // === CORREÇÃO DEFINITIVA: Sanitizar sem destruir a lista ===
    // Remover apenas $id de forma segura, sem usar limparReferenciasJson no modelo todo
    
    // 1. Converter listaRegularidadeFiscTrab para JSON puro (antes de qualquer processamento)
    if (model.listaRegularidadeFiscTrab && model.listaRegularidadeFiscTrab.length > 0) {
      console.log('%c[DEBUG-SERVICO-CADASTRO] ⚠️ Convertendo listaRegularidadeFiscTrab para JSON puro...', 'color: orange');
      model.listaRegularidadeFiscTrab = JSON.parse(JSON.stringify(model.listaRegularidadeFiscTrab));
      console.log('%c[DEBUG-SERVICO-CADASTRO] ✅ Lista convertida com sucesso:', { total: model.listaRegularidadeFiscTrab.length });
    }
    
    // 2. Remover $id de outras listas (de forma segura, item por item)
    if (model.listaQualificacaoTecnica) {
      model.listaQualificacaoTecnica.forEach((item) => {
        delete item.$id;
      });
    }

    if (model.listaDocumentosSolicitacao) {
      model.listaDocumentosSolicitacao.forEach((item) => {
        delete item.documentosSolicitacao.$id;
      });
    }

    if (model.fornecedorSolicitacao.uploadDeclaracao) {
      model.fornecedorSolicitacao.uploadDeclaracao.forEach((item) => {
        delete item.$id;
      });
    }

    if (model.fornecedorSolicitacao.documentosSolicitacao) {
      model.fornecedorSolicitacao.documentosSolicitacao.forEach((item) => {
        delete item.$id;
      });
    }
    
    // 3. Remover $id de regularidadeFiscTrab dentro de fornecedorSolicitacao (se existir)
    if (model.fornecedorSolicitacao.regularidadeFiscTrab) {
      model.fornecedorSolicitacao.regularidadeFiscTrab.forEach((item, chave) => {
        delete model.fornecedorSolicitacao.regularidadeFiscTrab[chave].$id;
        delete model.fornecedorSolicitacao.regularidadeFiscTrab[chave].fornecedorDispensa;
      });
    }
    
    // 4. Remover fornecedoresHabilitacaoJuridica
    if (model.fornecedorSolicitacao.fornecedoresHabilitacaoJuridica) {
      model.fornecedorSolicitacao.fornecedoresHabilitacaoJuridica = [];
    }
    
    // 5. Remover $id de modelQualificacao
    if (model.modelQualificacao) {
      delete model.modelQualificacao.$id;
    }
    
    console.log('%c[DEBUG-SERVICO-CADASTRO] model.listaRegularidadeFiscTrab após sanitização segura:', { 
      total: model.listaRegularidadeFiscTrab ? model.listaRegularidadeFiscTrab.length : 0,
      items: JSON.parse(JSON.stringify(model.listaRegularidadeFiscTrab)) 
    });
    
    if (model.listaRegularidadeFiscTrab && model.listaRegularidadeFiscTrab.length === 0) {
      console.error('%c[DEBUG-SERVICO-CADASTRO] ✗✗✗ ERRO CRÍTICO: listaRegularidadeFiscTrab está VAZIA!', 'background: #f44336; color: white; padding: 4px; font-size: 14px; font-weight: bold');
    }
    
    model.fornecedorSolicitacao.numCgcFornecedor = model.fornecedorSolicitacao.numCgcFornecedor.replace(/[\W_]+/g, '');
    
    console.log('%c[DEBUG-SERVICO-CADASTRO] ✅ Enviando para backend - listaRegularidadeFiscTrab:', { 
      total: model.listaRegularidadeFiscTrab ? model.listaRegularidadeFiscTrab.length : 0 
    });

    return BaseService.post("fornecedor/cadastrarfornecedor", model)
  },

  confirmarDadosFornecedor(idFornecSolicitacao) {
    return BaseService.post("fornecedor/confirmarDadosFornecedor?idFornecSolicitacao=" + idFornecSolicitacao);
  },

  habilitarRejeitarSolicitacao(model) {

    return BaseService.post("fornecedor/habilitarRejeitarSolicitacao", model)
  },

  cadastrarEditarHabJuridica(model, acao) {
    model.habilitacaoJuridica.numCgcFornecedor = model.habilitacaoJuridica.numCgcFornecedor.replace(/[\W_]+/g, '')
    model.habilitacaoJuridica.cpfCnpj = model.habilitacaoJuridica.cpfCnpj.replace(/[^A-Z0-9]/gi, '')

    if (acao === "incluir"){
      return BaseService.post("fornecedor/cadastrarhabilitacaojuridica", model)
    } else {
      return BaseService.post("fornecedor/editarhabilitacaojuridica", model)
    }
  },

  aprovarRejeitarHabilitacao(itemLista) {
    return BaseService.post("fornecedor/aprovarRejeitarHabilitacao", itemLista)
  },


  aprovarRejeitarArquivoUpload(model) {
    return BaseService.post("fornecedor/aprovarRejeitarArquivoUpload", model)
  },

  cadastroInicial(model) {
    return BaseService.post("fornecedor/CadastroInicial", model);
  },
  solicitarNovoCadastro(numCgcFornecedor) {
    return BaseService.get("fornecedor/solicitarnovocadastro?numCgcFornecedor=" + numCgcFornecedor);
  },
  solicitarAlteracaoHabilitador(numCgcFornecedor) {
    return BaseService.get("fornecedor/solicitarAlteracao?numCgcFornecedor=" + numCgcFornecedor + "&habilitador=1");
  },
  solicitarAlteracao(numCgcFornecedor) {
    return BaseService.get("fornecedor/solicitarAlteracao?numCgcFornecedor=" + numCgcFornecedor);
  },

  consultarDashboard(tipoDashboard, parametros = {}) {
    const query = [`tipoDashboard=${tipoDashboard}`];

    Object.keys(parametros).forEach((chave) => {
      const valor = parametros[chave];

      if (valor !== undefined && valor !== null && valor !== "") {
        query.push(`${chave}=${valor}`);
      }
    });

    return BaseService.get(`fornecedor/carregardashboard?${query.join("&")}`);
  },

  carregarDashboard(tipoDashboard) {
    return this.consultarDashboard(tipoDashboard);
  },

  consultarTipoSolicitacaoDashboard(ano) {
    return this.consultarDashboard(2, { ano });
  },

  consultarQuantitativoSolicitacoesDashboard(dataIni, dataFim) {
    return this.consultarDashboard(5, { dataIni, dataFim });
  },

  consultarQuantitativoSolicitacoesValidadorDashboard() {
    return this.consultarDashboard(6);
  },

  consultarQuantitativoSolicitacoesPorTipoDashboard() {
    return this.consultarDashboard(7);
  },

  consultarQuantitativoSolicitacoesPorTipoCadastroMasterDashboard(dataIni, dataFim) {
    return this.consultarDashboard(8, { dataIni, dataFim });
  },

  getDiasUltimaSolicitacao(idForneceSolicitacao) {
    return BaseService.get("fornecedor/obterDiasUltimaSolicitacao?idSolicitacao=" + idForneceSolicitacao);
  },

  put(model) {
    return BaseService.put("values", model);
  },

  baixarArquivo(arquivo, numCgcFornecedor = null) {
    BaseService.baixarArquivo(arquivo, numCgcFornecedor);
  },

  deleteFornecedorHabilitacaoJuridica(idFornecHabilitacaoJur) {
    return BaseService.delete("fornecedor/excluirHabilitacaoJuridica/" + idFornecHabilitacaoJur);
  },
  deleteArquivo(arquivo) {
    return BaseService.delete("arquivo/excluir/" + arquivo);
  },
  enviarFornecedor(model) {
    if (model.listaDocumentosSolicitacao) {

      model.listaDocumentosSolicitacao.forEach((item) => {

        delete item.documentosSolicitacao.$id;
      })
    }

    if (model.fornecedorSolicitacao.uploadDeclaracao) {

      model.fornecedorSolicitacao.uploadDeclaracao.forEach((item) => {

        delete item.$id;
      })
    }

    if (model.fornecedorSolicitacao.documentosSolicitacao) {

      model.fornecedorSolicitacao.documentosSolicitacao.forEach((item) => {

        delete item.$id;
      })
    }
    model.fornecedorSolicitacao.numCgcFornecedor = model.fornecedorSolicitacao.numCgcFornecedor.replace(/[\W_]+/g, '')
    return BaseService.post("fornecedor/enviarfornecedor", model)
  },
  upload(arquivo) {
    arquivo.UniqueName = arquivo.UniqueName.replace(/[\W_]+/g, '')
    return BaseService.post("arquivo/upload", arquivo)
  },
  confirmaEdicaoImpressaoTermo(idFornecSolicitacao){
    return BaseService.put(`fornecedor/confirmaEdicaoImpressaoTermo/${idFornecSolicitacao}`);
  },
  getTipoCertificadoCasdastradoSimpas(numCgcFornecedor){
    return BaseService.get(`fornecedor/certificadoCadastradoSimpas/${numCgcFornecedor}`);
  },
  getQtdSolicitcaoesFornec(numCgcFornecedor){
    return BaseService.get(`fornecedor/getQtdSolicitcaoesFornec/${numCgcFornecedor}`);
  },
  ObtemRegistroCadastral(numCgcFornecedor){
    return BaseService.get(`fornecedor/ObtemRegistroCadastral/${numCgcFornecedor}`);
  },
  GetDocRelatorioRegistroCadastral(numCgcFornecedor){
    return BaseService.get(`fornecedor/getDocRelatorioRegistroCadastral/${numCgcFornecedor}`);
  },
  ObtemSituacaoFornecedorSimeb(numCgcFornecedor) {
    return BaseService.get(`fornecedor/ConsultaFornecedorSimeb/${numCgcFornecedor}`);
  },
  getRegularidadeFiscalTipoDoc(numCgcFornecedor, tipoDoc) {
    return BaseService.get("fornecedor/GetRegularidadeFiscalTipoDoc?numCgcFornecedor=" + numCgcFornecedor + "&tipoDoc=" + tipoDoc);
  },
  exportarExcelRelatorios(filtros, tipoRelatorio) {
    const model = {
      dataInicial: filtros.dataInicial,
      dataFinal: filtros.dataFinal,
      usuarioAnalistaId: filtros.analistaId,
      opcaoRelatorioEscolhido: tipoRelatorio
    }
  
    return BaseService.exportarExcel(model, 4)
  },
};
